import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const MEDIUM_COLUMNS = 2;
const LARGE_COLUMNS = 4;
const EXTRA_LARGE_COLUMNS = 7;

// On extra large screens we show all filters on one line. In the last column there are 3 items, so we add some extra
// spacing so none of the items are too tight and cut off.
export const LAST_COLUMN_MARGIN = 4;

export const INPUT_GAP_SIZES = {
    medium: BaseStyle.GAP_SIZES.medium,
    large: BaseStyle.GAP_SIZES.large,
    extraLarge: BaseStyle.GAP_SIZES.semiMedium,
};

const getGridTemplateColumns = (columns, gapSize) => {
    const columnSize = 100 / columns;
    // x grid-gaps of gapSize divided by x + 1 columns
    const gridGap = (gapSize * (columns - 1)) / columns;
    return `repeat(${columns}, calc(${columnSize}% - ${gridGap}px))`;
};

/*  For the report options we're creating a grid of
    - mobile: N rows * 2 columns
    - desktop: N rows * 8 columns
    where N is any number
    On mobile it'll be around 5, on desktop 1. It adjusts to fit the content.

    NOTE fr = fraction | think of it like `flex: 1` for flexbox
*/
export const ReportOptionsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium};
    display: flex;
    flex-direction: column;
    padding: 24px 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        align-items: end;
        display: grid;
        grid-gap: 24px ${INPUT_GAP_SIZES.medium}px;
        grid-template-columns: ${getGridTemplateColumns(MEDIUM_COLUMNS, INPUT_GAP_SIZES.medium)};
        padding: 32px 0;
        width: 100%;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        grid-gap: ${INPUT_GAP_SIZES.large}px;
        grid-template-columns: ${getGridTemplateColumns(LARGE_COLUMNS, INPUT_GAP_SIZES.large)};
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        grid-gap: ${INPUT_GAP_SIZES.extraLarge}px;
        grid-template-columns: ${getGridTemplateColumns(
            EXTRA_LARGE_COLUMNS,
            INPUT_GAP_SIZES.extraLarge + LAST_COLUMN_MARGIN,
        )};
    }

    @media print {
        display: none;
    }
`;

export const FilterContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    align-items: end;
    display: flex;
    justify-content: end;

    ${BaseStyle.Mixins.screenSizes.medium} {
        grid-column: ${MEDIUM_COLUMNS} / ${MEDIUM_COLUMNS + 1};
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        grid-column: ${LARGE_COLUMNS} / ${LARGE_COLUMNS + 1};
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        grid-column: ${EXTRA_LARGE_COLUMNS} / ${EXTRA_LARGE_COLUMNS + 1};
        margin-right: -${EXTRA_LARGE_COLUMNS * LAST_COLUMN_MARGIN}px;
    }
`;

export const SelectContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium};
    display: flex;
    flex-direction: column;

    .MuiInput-root {
        .MuiInput-input {
            padding-right: 0;
        }
    }
    
    .MuiPopper-root {
        z-index: 3;
    }
`;
